import { combineReducers } from 'redux';
import { ApiReducerKey } from 'constants/index';
import list from './list';

export default combineReducers({ [ApiReducerKey.LIST]: list });
